var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"podopieczny-jesli-udost-root"},[_vm._v("\n  Jeśli udostępnisz profil, więcej osób\n  będzie wspierać Podopiecznego.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }